import { KeywordsByAdvertisers } from '../keywords-by-advertisers/KeywordsByAdvertisers'
import { KeywordsTable } from '../keywords-table/KeywordsTable'
import clsx from 'clsx'

import styles from './Keywords.module.scss'

export const Keywords = () => {
  return (
    <section className={clsx(styles.wrapper)}>
      <KeywordsByAdvertisers />
      <KeywordsTable />
    </section>
  )
}
